"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var transport_1 = __importDefault(require("./transport"));
var transport_error_1 = require("./transport-error");
var params_1 = require("./params");
var unrecoverable_1 = require("./unrecoverable");
var idleConnectionExitCode = 3000;
var WS = /** @class */ (function (_super) {
    __extends(WS, _super);
    function WS(url, instanceUpdater, siteRevision) {
        if (instanceUpdater === void 0) { instanceUpdater = null; }
        var _this = _super.call(this, { keepAlive: true }) || this;
        _this.url = url;
        _this.instanceUpdater = instanceUpdater;
        _this.siteRevision = siteRevision;
        return _this;
    }
    WS.isSupported = function () {
        return typeof WebSocket !== 'undefined';
    };
    Object.defineProperty(WS.prototype, "name", {
        get: function () {
            return 'websocket';
        },
        enumerable: true,
        configurable: true
    });
    WS.prototype.doOpen = function () {
        var params = params_1.createParams(this.instanceUpdater, this.siteRevision);
        var url = params_1.withParams(this.url, params);
        var opts = process.env.DUPLEXER_NODE_ENV === 'true'
            ? { headers: maybeHeaders(this.instanceUpdater) }
            : undefined;
        if (this.ws) {
            this.ws.onmessage = function () { };
            this.ws.onclose = function () { };
            this.doClose();
        }
        this.ws = new WebSocket(url, opts);
        this.listen();
    };
    WS.prototype.doClose = function () {
        // Normal closure; the connection successfully completed whatever purpose for which it was created.
        // More info here: https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent
        this.ws && this.ws.close(1000);
    };
    WS.prototype.write = function (packet) {
        var normalized = JSON.stringify(packet);
        this.ws.send(normalized);
    };
    WS.prototype.listen = function () {
        var _this = this;
        this.ws.onclose = function (event) {
            var error = null;
            // network error
            if (!event.wasClean) {
                error = transport_error_1.aWebSocketError({
                    status: event.code,
                    message: event.reason,
                    recoverable: true,
                });
            }
            else if (
            // sent by sockets service
            unrecoverable_1.isUnrecoverableCode(toCode(event.code)) ||
                event.code === idleConnectionExitCode) {
                error = transport_error_1.aWebSocketError({
                    status: event.code,
                    message: event.reason,
                    recoverable: false,
                });
            }
            if (error) {
                _this.onClose(error);
            }
        };
        this.ws.onmessage = function (ev) {
            var normalized = JSON.parse(ev.data);
            _this.onData(normalized);
        };
        this.ws.onerror = function () { };
    };
    return WS;
}(transport_1.default));
exports.default = WS;
function toCode(wsCode) {
    return parseInt(wsCode.toString().substr(1), 10);
}
function maybeHeaders(instanceUpdater) {
    return ((instanceUpdater &&
        instanceUpdater.getHeaders &&
        instanceUpdater.getHeaders()) ||
        {});
}
//# sourceMappingURL=websocket.js.map